export const NON_REP_LABEL = {
  freelance: 'Freelance',
  non_represented: 'Non-Represented',
  personal_profile: 'Personal Profile',
};
